//use client mode and init on use effect for react

declare global {
    interface Window {
        pdfjsLib?: any;
    }
}

export class PDF {
    url:string=""
    pageIndex:number=1
    pageCount:number=0
    scale:number=1
    maxScale:number=2
    minScale:number=1
    containerRef?:null
    canvas:Array<HTMLCanvasElement>=[]
    ctx:Array<CanvasRenderingContext2D>=[]
    pdfDoc:any
    script?:any
    spreadMode:number=1 || 2
    isRendered:boolean=false
    isRendered2:boolean=false
    isRendered3:boolean=false
    initWidth:number=0
    initHeight:number=0
    isLastPage:boolean=false

    constructor(url:string) {
        this.url=url
    }

    private CreateCanvas(canvasContainerRefDom:HTMLElement) {
        const canvasElm: HTMLCanvasElement=document.createElement("CANVAS") as HTMLCanvasElement
        canvasContainerRefDom.appendChild(canvasElm)
        this.canvas.push(canvasElm)
        this.ctx.push(canvasElm.getContext('2d') as CanvasRenderingContext2D)

        if(this.spreadMode==2){
            const canvasElm2: HTMLCanvasElement=document.createElement("CANVAS") as HTMLCanvasElement
            canvasContainerRefDom.appendChild(canvasElm2)
            this.canvas.push(canvasElm2)
            this.ctx.push(canvasElm2.getContext('2d') as CanvasRenderingContext2D)
        }
        
    }

    private RenderPDF(){
        if(this.pageIndex>this.pageCount)return
        const _this=this
        if(this.spreadMode==1){           
            this.isRendered=false            
            this.isLastPage=this.pageIndex==this.pageCount
            this.pdfDoc.getPage(this.pageIndex).then((page:any)=>{
                const viewport = page.getViewport({scale: this.scale})
                this.canvas[0].height = viewport.height
                this.canvas[0].width = viewport.width
    
                const renderContext = {
                    canvasContext: this.ctx[0],
                    viewport: viewport
                };
                page.render(renderContext).promise.then(()=>{
                    _this.isRendered=true
                })
            }) 
        }
        else if(this.spreadMode==2){
            this.isRendered2=false  
            this.pdfDoc.getPage(this.pageIndex).then((page:any)=>{
                const viewport = page.getViewport({scale: this.scale})
                this.canvas[0].height = viewport.height
                this.canvas[0].width = viewport.width
    
                const renderContext = {
                    canvasContext: this.ctx[0],
                    viewport: viewport
                };
                page.render(renderContext).promise.then(()=>{
                    _this.isRendered2=true
                })
            })
            const pageNum=this.pageIndex+1   
            this.isLastPage= pageNum>=this.pageCount      
            if(pageNum<=this.pageCount){
                this.isRendered3=false
                this.pdfDoc.getPage(pageNum).then((page:any)=>{
                const viewport = page.getViewport({scale: this.scale})
                this.canvas[1].height = viewport.height
                this.canvas[1].width = viewport.width
    
                const renderContext = {
                    canvasContext: this.ctx[1],
                    viewport: viewport
                };
                    page.render(renderContext).promise.then(()=>{
                        _this.isRendered3=true
                    })
                }) 
            }
            else{
                this.ctx[1].clearRect(0,0,this.canvas[1].width,this.canvas[1].height)
                this.ctx[1].fillStyle = "white"
                this.ctx[1].fillRect(0,0,this.canvas[1].width,this.canvas[1].height)
                this.isRendered3=true
            }
        }
    }

    IsPageReady(){
        if(this.spreadMode==2){
            return this.isRendered2&&this.isRendered3;
        }
        else{
            return this.isRendered;
        }        
    }

    TriggerCurrenPage(pageIndex:number,callback?:Function){  
        if(!this.IsPageReady()){
            return
        }
        if(pageIndex<=0){
            pageIndex+=1
        }
        if(pageIndex>this.pageCount){
            pageIndex-=1
        }
        this.pageIndex=pageIndex
        this.RenderPDF()
        if(callback){
            callback(this.pageIndex,this.pageCount,this.spreadMode,this.isLastPage)
        }
    }

    TriggerPrev(callback?:Function){   
        if(!this.IsPageReady()){
            return
        } 
        if(this.pageIndex<=1){
            return
        }
        if(this.spreadMode==2){
            this.pageIndex-=2
        }
        else{
            this.pageIndex--
        }   
        this.RenderPDF()
        if(callback){
            callback(this.pageIndex,this.pageCount,this.spreadMode,this.isLastPage)
        }
    }
    TriggerNext(callback?:Function){
        if(!this.IsPageReady()){
            return
        }
        if(this.pageIndex>=this.pageCount){
            return
        }

        if(this.spreadMode==2){
            this.pageIndex+=2
        }
        else{
            this.pageIndex++
        }
        
        this.RenderPDF()
        if(callback){
            callback(this.pageIndex,this.pageCount,this.spreadMode,this.isLastPage)
        }
    }

    TriggerScale(scale:number,callback?:Function){
        if(!this.IsPageReady()){
            return
        } 
        if(scale<100||scale>200){
            if(callback){
                callback(scale,false)
            }
            return
        }    
        let _scale=this.scale
        if(scale==100){
            _scale=this.minScale
        }
        else if(scale==200){
            _scale=this.maxScale
        }
        else{
            _scale=this.minScale*scale/100
        }
        if(this.minScale<=_scale&&_scale<=this.maxScale){            
            this.scale=_scale
            this.RenderPDF()
            if(callback){
                callback(scale,true)
            }
        }
        else{
            if(callback){
                callback(scale,false)
            }
        }
        
    }

    async DownloadFile(){
        const filename= this.url.split("?")[0].replace(/^.*[\\/]/, "")
        const data=await this.pdfDoc.getData()        
        const blobUrl=URL.createObjectURL(
            new Blob([data], { type: "application/octet-stream" })
        )
        const a = document.createElement("a")
        a.href = blobUrl;
        a.target = "_parent";
        a.download = filename;
        (document.body || document.documentElement).append(a);
        a.click();
        a.remove();
    }

    async GetInitViewPort(){
        let viewport=null
        await this.pdfDoc.getPage(this.pageIndex).then((page:any)=>{
            viewport = page.getViewport({scale: this.scale})
        }) 
        return viewport
    }

    async SetInitScale(){
        const _this=this
        const initViewPort = this.GetInitViewPort()
        await initViewPort.then((viewport:any)=>{
            let _initwidth=_this.initWidth
            let _initheight=_this.initHeight
            if(_this.spreadMode==2){
                _initwidth=_this.initWidth/2-5
            }

            if(_initwidth>viewport.width&&_initheight>viewport.height){
                return
            }
            if(_initwidth<=viewport.width){
                _this.scale=Number((_initwidth/viewport.width).toFixed(2))

                if(_this.scale*viewport.height>_initheight){
                    const _height=_initheight*_this.scale
                    _this.scale=Number((_height/viewport.height).toFixed(2))
                }
                _this.minScale=_this.minScale*_this.scale
                _this.maxScale=_this.minScale*2
            }
            else if(_this.initHeight<viewport.height){
                _this.scale=Number((_this.initHeight/viewport.height).toFixed(2))

                if(_this.scale*viewport.width>_initwidth){
                    const _width=_initwidth*_this.scale
                    _this.scale=Number((_width/viewport.width).toFixed(2))
                    
                }
                _this.minScale=_this.minScale*_this.scale
                _this.maxScale=_this.minScale*2
                     
                // console.log("---initHeight---")
            }
            
            // console.log("initHeight",_this.initHeight)
            // console.log("initWidth",_this.initWidth)
            // console.log("viewport",viewport)
        })
    }

    async LoadPdf(src = {},callback?:Function){
        const pdfjsLib=window.pdfjsLib
        const _this=this

        if (typeof src === "string" || src instanceof URL) {
            pdfjsLib.getDocument(this.url).promise.then(async (pdfDoc:any)=> {
                _this.pdfDoc=pdfDoc
                _this.pageCount = pdfDoc.numPages                
                await _this.SetInitScale()
                _this.RenderPDF()
                if(callback){
                    callback(_this.pageIndex,_this.pageCount,_this.spreadMode)
                }
            });
        } else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) {
            pdfjsLib.getDocument({data:src}).promise.then(async(pdfDoc:any)=> {
                _this.pdfDoc=pdfDoc
                _this.pageCount = pdfDoc.numPages
                await _this.SetInitScale()
                _this.RenderPDF()
                if(callback){
                    callback(_this.pageIndex,_this.pageCount,_this.spreadMode)
                }
            });
        }
    }

    Mount(assetPrefix:string, ContainerRef:any, callback?:Function){
        this.containerRef=ContainerRef
        this.CreateCanvas(ContainerRef.current)

        this.script = document.createElement('script');
        this.script.src = `${assetPrefix}/pdfjs/pdf.mjs`;
        this.script.type = "module";
        this.script.async = true;
        document.head.appendChild(this.script);
        this.script.onload= async ()=>{
            const pdfjsLib=window.pdfjsLib
            pdfjsLib.GlobalWorkerOptions.workerSrc=`${assetPrefix}/pdfjs/pdf.worker.mjs`

            try{                
                const pdfData=await fetch(this.url)
                const arrayBufferPdf= await pdfData.arrayBuffer()
                this.LoadPdf(arrayBufferPdf,callback)
            }
            catch(e){
                alert(`Load Pdf Error:${e}`)// for test
                this.LoadPdf(this.url,callback)
            }
            
        }
    }

    UnMount(){
        document.head.removeChild(this.script);
        this.canvas.map((item,index)=>{
            item.remove()
        })
    }
}